export enum PaymentStatus {
  Invoiced = "Invoiced",
  Received = "Received",
  Overdue = "Overdue",
  Voided = "Voided",
  Draft = "Draft",
}
